import { useMutation, useQuery } from 'react-query';
import { fetcher } from './fetcher.js';
import 'agentkeepalive';
import 'axios';

var AddRecentlyViewedBooksResponseStatus = /* @__PURE__ */ ((AddRecentlyViewedBooksResponseStatus2) => {
  AddRecentlyViewedBooksResponseStatus2["Success"] = "SUCCESS";
  return AddRecentlyViewedBooksResponseStatus2;
})(AddRecentlyViewedBooksResponseStatus || {});
var AddRidiAwardGenreVoteStatus = /* @__PURE__ */ ((AddRidiAwardGenreVoteStatus2) => {
  AddRidiAwardGenreVoteStatus2["AlreadyVoted"] = "ALREADY_VOTED";
  AddRidiAwardGenreVoteStatus2["InvalidAward"] = "INVALID_AWARD";
  AddRidiAwardGenreVoteStatus2["InvalidSections"] = "INVALID_SECTIONS";
  AddRidiAwardGenreVoteStatus2["InvalidVotes"] = "INVALID_VOTES";
  AddRidiAwardGenreVoteStatus2["InvalidWriteInVotes"] = "INVALID_WRITE_IN_VOTES";
  AddRidiAwardGenreVoteStatus2["NotEligible"] = "NOT_ELIGIBLE";
  AddRidiAwardGenreVoteStatus2["Success"] = "SUCCESS";
  return AddRidiAwardGenreVoteStatus2;
})(AddRidiAwardGenreVoteStatus || {});
var AddWishlistStatus = /* @__PURE__ */ ((AddWishlistStatus2) => {
  AddWishlistStatus2["AlreadyInWishlist"] = "ALREADY_IN_WISHLIST";
  AddWishlistStatus2["AlreadyPurchased"] = "ALREADY_PURCHASED";
  AddWishlistStatus2["MaxSizeExceeded"] = "MAX_SIZE_EXCEEDED";
  AddWishlistStatus2["Success"] = "SUCCESS";
  return AddWishlistStatus2;
})(AddWishlistStatus || {});
var AdultOption = /* @__PURE__ */ ((AdultOption2) => {
  AdultOption2["AppAll"] = "APP_ALL";
  AdultOption2["ExcludeAdult"] = "EXCLUDE_ADULT";
  AdultOption2["None"] = "NONE";
  AdultOption2["OnlyAdult"] = "ONLY_ADULT";
  return AdultOption2;
})(AdultOption || {});
var AdultVerificationStatus = /* @__PURE__ */ ((AdultVerificationStatus2) => {
  AdultVerificationStatus2["Expired"] = "EXPIRED";
  AdultVerificationStatus2["NotVerified"] = "NOT_VERIFIED";
  AdultVerificationStatus2["Verified"] = "VERIFIED";
  return AdultVerificationStatus2;
})(AdultVerificationStatus || {});
var AppMarketingBridgeButtonType = /* @__PURE__ */ ((AppMarketingBridgeButtonType2) => {
  AppMarketingBridgeButtonType2["Continue"] = "CONTINUE";
  AppMarketingBridgeButtonType2["FirstEpisode"] = "FIRST_EPISODE";
  AppMarketingBridgeButtonType2["Home"] = "HOME";
  return AppMarketingBridgeButtonType2;
})(AppMarketingBridgeButtonType || {});
var AsyncCellLoadTiming = /* @__PURE__ */ ((AsyncCellLoadTiming2) => {
  AsyncCellLoadTiming2["OnRender"] = "ON_RENDER";
  AsyncCellLoadTiming2["OnView"] = "ON_VIEW";
  return AsyncCellLoadTiming2;
})(AsyncCellLoadTiming || {});
var AuthorRole = /* @__PURE__ */ ((AuthorRole2) => {
  AuthorRole2["Adapter"] = "ADAPTER";
  AuthorRole2["Author"] = "AUTHOR";
  AuthorRole2["AuthorPhoto"] = "AUTHOR_PHOTO";
  AuthorRole2["BibliographicalIntroduction"] = "BIBLIOGRAPHICAL_INTRODUCTION";
  AuthorRole2["Commentator"] = "COMMENTATOR";
  AuthorRole2["Compiler"] = "COMPILER";
  AuthorRole2["Editor"] = "EDITOR";
  AuthorRole2["Illustrator"] = "ILLUSTRATOR";
  AuthorRole2["OriginalAuthor"] = "ORIGINAL_AUTHOR";
  AuthorRole2["OriginalIllustrator"] = "ORIGINAL_ILLUSTRATOR";
  AuthorRole2["Performer"] = "PERFORMER";
  AuthorRole2["Planner"] = "PLANNER";
  AuthorRole2["StoryWriter"] = "STORY_WRITER";
  AuthorRole2["Supervise"] = "SUPERVISE";
  AuthorRole2["Translator"] = "TRANSLATOR";
  return AuthorRole2;
})(AuthorRole || {});
var BadgeType = /* @__PURE__ */ ((BadgeType2) => {
  BadgeType2["Discount"] = "DISCOUNT";
  BadgeType2["FreeSeries"] = "FREE_SERIES";
  BadgeType2["Only"] = "ONLY";
  BadgeType2["PartialFree"] = "PARTIAL_FREE";
  BadgeType2["Rent"] = "RENT";
  BadgeType2["Select"] = "SELECT";
  BadgeType2["Up"] = "UP";
  BadgeType2["WaitFree"] = "WAIT_FREE";
  return BadgeType2;
})(BadgeType || {});
var BannerPlace = /* @__PURE__ */ ((BannerPlace2) => {
  BannerPlace2["DetailAside"] = "DETAIL_ASIDE";
  BannerPlace2["DetailAsideCommonBottom"] = "DETAIL_ASIDE_COMMON_BOTTOM";
  BannerPlace2["ViewerBottomApp"] = "VIEWER_BOTTOM_APP";
  BannerPlace2["ViewerBottomWeb"] = "VIEWER_BOTTOM_WEB";
  return BannerPlace2;
})(BannerPlace || {});
var BestsellerPeriod = /* @__PURE__ */ ((BestsellerPeriod2) => {
  BestsellerPeriod2["Daily"] = "DAILY";
  BestsellerPeriod2["Monthly"] = "MONTHLY";
  BestsellerPeriod2["Steady"] = "STEADY";
  BestsellerPeriod2["Weekly"] = "WEEKLY";
  return BestsellerPeriod2;
})(BestsellerPeriod || {});
var BookDetailHomeBaseReviewType = /* @__PURE__ */ ((BookDetailHomeBaseReviewType2) => {
  BookDetailHomeBaseReviewType2["MyReview"] = "MY_REVIEW";
  BookDetailHomeBaseReviewType2["UserReview"] = "USER_REVIEW";
  return BookDetailHomeBaseReviewType2;
})(BookDetailHomeBaseReviewType || {});
var BookDetailHomeEpisodeBookListFirstCallOption = /* @__PURE__ */ ((BookDetailHomeEpisodeBookListFirstCallOption2) => {
  BookDetailHomeEpisodeBookListFirstCallOption2["LastRead"] = "LAST_READ";
  BookDetailHomeEpisodeBookListFirstCallOption2["LastReadWithPadding"] = "LAST_READ_WITH_PADDING";
  BookDetailHomeEpisodeBookListFirstCallOption2["Latest"] = "LATEST";
  BookDetailHomeEpisodeBookListFirstCallOption2["Sequential"] = "SEQUENTIAL";
  return BookDetailHomeEpisodeBookListFirstCallOption2;
})(BookDetailHomeEpisodeBookListFirstCallOption || {});
var BookDetailHomeEpisodeBookOrder = /* @__PURE__ */ ((BookDetailHomeEpisodeBookOrder2) => {
  BookDetailHomeEpisodeBookOrder2["LastPurchased"] = "LAST_PURCHASED";
  BookDetailHomeEpisodeBookOrder2["Latest"] = "LATEST";
  BookDetailHomeEpisodeBookOrder2["Sequential"] = "SEQUENTIAL";
  return BookDetailHomeEpisodeBookOrder2;
})(BookDetailHomeEpisodeBookOrder || {});
var BookDetailHomeEpisodeBookOwnershipStatus = /* @__PURE__ */ ((BookDetailHomeEpisodeBookOwnershipStatus2) => {
  BookDetailHomeEpisodeBookOwnershipStatus2["Normal"] = "NORMAL";
  BookDetailHomeEpisodeBookOwnershipStatus2["Rent"] = "RENT";
  BookDetailHomeEpisodeBookOwnershipStatus2["RentExpired"] = "RENT_EXPIRED";
  BookDetailHomeEpisodeBookOwnershipStatus2["Ridiselect"] = "RIDISELECT";
  return BookDetailHomeEpisodeBookOwnershipStatus2;
})(BookDetailHomeEpisodeBookOwnershipStatus || {});
var BookDetailHomeEpisodeBookPaginationDirection = /* @__PURE__ */ ((BookDetailHomeEpisodeBookPaginationDirection2) => {
  BookDetailHomeEpisodeBookPaginationDirection2["Next"] = "NEXT";
  BookDetailHomeEpisodeBookPaginationDirection2["Prev"] = "PREV";
  return BookDetailHomeEpisodeBookPaginationDirection2;
})(BookDetailHomeEpisodeBookPaginationDirection || {});
var BookDetailHomeHeaderButtonAction = /* @__PURE__ */ ((BookDetailHomeHeaderButtonAction2) => {
  BookDetailHomeHeaderButtonAction2["AddCart"] = "ADD_CART";
  BookDetailHomeHeaderButtonAction2["AddWishlist"] = "ADD_WISHLIST";
  BookDetailHomeHeaderButtonAction2["BuyBook"] = "BUY_BOOK";
  BookDetailHomeHeaderButtonAction2["BuyEbookCashback"] = "BUY_EBOOK_CASHBACK";
  BookDetailHomeHeaderButtonAction2["BuySeries"] = "BUY_SERIES";
  BookDetailHomeHeaderButtonAction2["Download"] = "DOWNLOAD";
  BookDetailHomeHeaderButtonAction2["FreeDownload"] = "FREE_DOWNLOAD";
  BookDetailHomeHeaderButtonAction2["Gift"] = "GIFT";
  BookDetailHomeHeaderButtonAction2["Pointback"] = "POINTBACK";
  BookDetailHomeHeaderButtonAction2["RedirectToApp"] = "REDIRECT_TO_APP";
  BookDetailHomeHeaderButtonAction2["RedirectToPcViewer"] = "REDIRECT_TO_PC_VIEWER";
  BookDetailHomeHeaderButtonAction2["RemoveCart"] = "REMOVE_CART";
  BookDetailHomeHeaderButtonAction2["RemoveWishlist"] = "REMOVE_WISHLIST";
  BookDetailHomeHeaderButtonAction2["RentBook"] = "RENT_BOOK";
  BookDetailHomeHeaderButtonAction2["RentSeries"] = "RENT_SERIES";
  BookDetailHomeHeaderButtonAction2["ViewFirstBook"] = "VIEW_FIRST_BOOK";
  BookDetailHomeHeaderButtonAction2["ViewFromLatestReadBook"] = "VIEW_FROM_LATEST_READ_BOOK";
  BookDetailHomeHeaderButtonAction2["ViewWebViewer"] = "VIEW_WEB_VIEWER";
  return BookDetailHomeHeaderButtonAction2;
})(BookDetailHomeHeaderButtonAction || {});
var BookDetailHomeReviewOrder = /* @__PURE__ */ ((BookDetailHomeReviewOrder2) => {
  BookDetailHomeReviewOrder2["Like"] = "LIKE";
  BookDetailHomeReviewOrder2["RatingAsc"] = "RATING_ASC";
  BookDetailHomeReviewOrder2["RatingDesc"] = "RATING_DESC";
  BookDetailHomeReviewOrder2["Recent"] = "RECENT";
  return BookDetailHomeReviewOrder2;
})(BookDetailHomeReviewOrder || {});
var CacheControlScope = /* @__PURE__ */ ((CacheControlScope2) => {
  CacheControlScope2["Private"] = "PRIVATE";
  CacheControlScope2["Public"] = "PUBLIC";
  return CacheControlScope2;
})(CacheControlScope || {});
var CategoryGenreFilterRangeType = /* @__PURE__ */ ((CategoryGenreFilterRangeType2) => {
  CategoryGenreFilterRangeType2["Category"] = "CATEGORY";
  CategoryGenreFilterRangeType2["Genre"] = "GENRE";
  return CategoryGenreFilterRangeType2;
})(CategoryGenreFilterRangeType || {});
var CellBindingType = /* @__PURE__ */ ((CellBindingType2) => {
  CellBindingType2["AppMarketingBridgeButton"] = "AppMarketingBridgeButton";
  CellBindingType2["AppMarketingBridgeHeader"] = "AppMarketingBridgeHeader";
  CellBindingType2["AppMarketingBridgeInstallBanner"] = "AppMarketingBridgeInstallBanner";
  CellBindingType2["AppMarketingBridgeIntroduction"] = "AppMarketingBridgeIntroduction";
  CellBindingType2["AppMarketingBridgePreview"] = "AppMarketingBridgePreview";
  CellBindingType2["AppMarketingBridgeRoot"] = "AppMarketingBridgeRoot";
  CellBindingType2["AppMarketingBridgeSimilarPurchasedBookList"] = "AppMarketingBridgeSimilarPurchasedBookList";
  CellBindingType2["AppMarketingBridgeThumbnail"] = "AppMarketingBridgeThumbnail";
  CellBindingType2["Async"] = "Async";
  CellBindingType2["BookDetailHomeAsideBottomBanner"] = "BookDetailHomeAsideBottomBanner";
  CellBindingType2["BookDetailHomeAsideTopBanner"] = "BookDetailHomeAsideTopBanner";
  CellBindingType2["BookDetailHomeAuthorIntroduction"] = "BookDetailHomeAuthorIntroduction";
  CellBindingType2["BookDetailHomeAuthorProfile"] = "BookDetailHomeAuthorProfile";
  CellBindingType2["BookDetailHomeAuthorProfileTab"] = "BookDetailHomeAuthorProfileTab";
  CellBindingType2["BookDetailHomeAuthorTab"] = "BookDetailHomeAuthorTab";
  CellBindingType2["BookDetailHomeBestseller"] = "BookDetailHomeBestseller";
  CellBindingType2["BookDetailHomeBlGuide"] = "BookDetailHomeBlGuide";
  CellBindingType2["BookDetailHomeBookGuide"] = "BookDetailHomeBookGuide";
  CellBindingType2["BookDetailHomeBookIntroduction"] = "BookDetailHomeBookIntroduction";
  CellBindingType2["BookDetailHomeCollectionBookList"] = "BookDetailHomeCollectionBookList";
  CellBindingType2["BookDetailHomeDescriptionTab"] = "BookDetailHomeDescriptionTab";
  CellBindingType2["BookDetailHomeEpisodeBookList"] = "BookDetailHomeEpisodeBookList";
  CellBindingType2["BookDetailHomeEventPanel"] = "BookDetailHomeEventPanel";
  CellBindingType2["BookDetailHomeFantasyFreeBookPanel"] = "BookDetailHomeFantasyFreeBookPanel";
  CellBindingType2["BookDetailHomeGuideTab"] = "BookDetailHomeGuideTab";
  CellBindingType2["BookDetailHomeHeader"] = "BookDetailHomeHeader";
  CellBindingType2["BookDetailHomeIpGoods"] = "BookDetailHomeIpGoods";
  CellBindingType2["BookDetailHomeKeywordBookList"] = "BookDetailHomeKeywordBookList";
  CellBindingType2["BookDetailHomeKeywordTab"] = "BookDetailHomeKeywordTab";
  CellBindingType2["BookDetailHomeLinkedContents"] = "BookDetailHomeLinkedContents";
  CellBindingType2["BookDetailHomeLowerPanelList"] = "BookDetailHomeLowerPanelList";
  CellBindingType2["BookDetailHomeMetadata"] = "BookDetailHomeMetadata";
  CellBindingType2["BookDetailHomeNotFoundBook"] = "BookDetailHomeNotFoundBook";
  CellBindingType2["BookDetailHomeNoticePanel"] = "BookDetailHomeNoticePanel";
  CellBindingType2["BookDetailHomeOperationPanel"] = "BookDetailHomeOperationPanel";
  CellBindingType2["BookDetailHomePublisherReview"] = "BookDetailHomePublisherReview";
  CellBindingType2["BookDetailHomeRelatedSeriesInfo"] = "BookDetailHomeRelatedSeriesInfo";
  CellBindingType2["BookDetailHomeReview"] = "BookDetailHomeReview";
  CellBindingType2["BookDetailHomeRomanceGuide"] = "BookDetailHomeRomanceGuide";
  CellBindingType2["BookDetailHomeRoot"] = "BookDetailHomeRoot";
  CellBindingType2["BookDetailHomeSequenceBookList"] = "BookDetailHomeSequenceBookList";
  CellBindingType2["BookDetailHomeSequenceGuide"] = "BookDetailHomeSequenceGuide";
  CellBindingType2["BookDetailHomeSeriesMemberBookList"] = "BookDetailHomeSeriesMemberBookList";
  CellBindingType2["BookDetailHomeSetAndSeriesPurchasePanel"] = "BookDetailHomeSetAndSeriesPurchasePanel";
  CellBindingType2["BookDetailHomeSetBookList"] = "BookDetailHomeSetBookList";
  CellBindingType2["BookDetailHomeSetMemberBookList"] = "BookDetailHomeSetMemberBookList";
  CellBindingType2["BookDetailHomeSimilarPurchasedBookList"] = "BookDetailHomeSimilarPurchasedBookList";
  CellBindingType2["BookDetailHomeSimilarViewedBookList"] = "BookDetailHomeSimilarViewedBookList";
  CellBindingType2["BookDetailHomeTableOfContents"] = "BookDetailHomeTableOfContents";
  CellBindingType2["BookDetailHomeTitleDuplicateBookList"] = "BookDetailHomeTitleDuplicateBookList";
  CellBindingType2["BookDetailHomeTrailer"] = "BookDetailHomeTrailer";
  CellBindingType2["BookDetailHomeUpperPanelList"] = "BookDetailHomeUpperPanelList";
  CellBindingType2["Flex"] = "Flex";
  CellBindingType2["GenreHomeImageGradientBanner"] = "GenreHomeImageGradientBanner";
  CellBindingType2["SearchAuthorList"] = "SearchAuthorList";
  CellBindingType2["SearchBookList"] = "SearchBookList";
  CellBindingType2["SearchBookListWithTab"] = "SearchBookListWithTab";
  CellBindingType2["SearchEventList"] = "SearchEventList";
  CellBindingType2["SearchKeywordList"] = "SearchKeywordList";
  CellBindingType2["SearchKeywordSectionList"] = "SearchKeywordSectionList";
  CellBindingType2["SearchRoot"] = "SearchRoot";
  return CellBindingType2;
})(CellBindingType || {});
var CellLayout = /* @__PURE__ */ ((CellLayout2) => {
  CellLayout2["AppMarketingBridgeBlankButton"] = "AppMarketingBridgeBlankButton";
  CellLayout2["AppMarketingBridgeCoverHeader"] = "AppMarketingBridgeCoverHeader";
  CellLayout2["AppMarketingBridgeCoverRowHeader"] = "AppMarketingBridgeCoverRowHeader";
  CellLayout2["AppMarketingBridgeDoubleRowThumbnail"] = "AppMarketingBridgeDoubleRowThumbnail";
  CellLayout2["AppMarketingBridgeInstallBanner"] = "AppMarketingBridgeInstallBanner";
  CellLayout2["AppMarketingBridgeIntroduction"] = "AppMarketingBridgeIntroduction";
  CellLayout2["AppMarketingBridgeMultilineBookList"] = "AppMarketingBridgeMultilineBookList";
  CellLayout2["AppMarketingBridgePreview"] = "AppMarketingBridgePreview";
  CellLayout2["AppMarketingBridgePrimaryButton"] = "AppMarketingBridgePrimaryButton";
  CellLayout2["AppMarketingBridgeRoot"] = "AppMarketingBridgeRoot";
  CellLayout2["AppMarketingBridgeSingleRowThumbnail"] = "AppMarketingBridgeSingleRowThumbnail";
  CellLayout2["AppMarketingBridgeThumbnailHeader"] = "AppMarketingBridgeThumbnailHeader";
  CellLayout2["AsideBanner"] = "AsideBanner";
  CellLayout2["Async"] = "Async";
  CellLayout2["BookDetailHomeAuthorIntroduction"] = "BookDetailHomeAuthorIntroduction";
  CellLayout2["BookDetailHomeAuthorProfile"] = "BookDetailHomeAuthorProfile";
  CellLayout2["BookDetailHomeAuthorProfileTab"] = "BookDetailHomeAuthorProfileTab";
  CellLayout2["BookDetailHomeBestseller"] = "BookDetailHomeBestseller";
  CellLayout2["BookDetailHomeBookIntroduction"] = "BookDetailHomeBookIntroduction";
  CellLayout2["BookDetailHomeEpisodeBookList"] = "BookDetailHomeEpisodeBookList";
  CellLayout2["BookDetailHomeGuide"] = "BookDetailHomeGuide";
  CellLayout2["BookDetailHomeHeader"] = "BookDetailHomeHeader";
  CellLayout2["BookDetailHomeIpGoods"] = "BookDetailHomeIpGoods";
  CellLayout2["BookDetailHomeKeywordBookList"] = "BookDetailHomeKeywordBookList";
  CellLayout2["BookDetailHomeKeywordTab"] = "BookDetailHomeKeywordTab";
  CellLayout2["BookDetailHomeLinkedContents"] = "BookDetailHomeLinkedContents";
  CellLayout2["BookDetailHomeMetadata"] = "BookDetailHomeMetadata";
  CellLayout2["BookDetailHomeNotFoundBook"] = "BookDetailHomeNotFoundBook";
  CellLayout2["BookDetailHomePublisherReview"] = "BookDetailHomePublisherReview";
  CellLayout2["BookDetailHomeRelatedSeriesInfo"] = "BookDetailHomeRelatedSeriesInfo";
  CellLayout2["BookDetailHomeReview"] = "BookDetailHomeReview";
  CellLayout2["BookDetailHomeRoot"] = "BookDetailHomeRoot";
  CellLayout2["BookDetailHomeSequenceGuide"] = "BookDetailHomeSequenceGuide";
  CellLayout2["BookDetailHomeSetBookList"] = "BookDetailHomeSetBookList";
  CellLayout2["BookDetailHomeSetMemberBookList"] = "BookDetailHomeSetMemberBookList";
  CellLayout2["BookDetailHomeTableOfContents"] = "BookDetailHomeTableOfContents";
  CellLayout2["BookDetailHomeTrailer"] = "BookDetailHomeTrailer";
  CellLayout2["BookList"] = "BookList";
  CellLayout2["FlexColumn"] = "FlexColumn";
  CellLayout2["GeneralTab"] = "GeneralTab";
  CellLayout2["GenreHomeImageGradientBanner"] = "GenreHomeImageGradientBanner";
  CellLayout2["Panel"] = "Panel";
  CellLayout2["PanelList"] = "PanelList";
  CellLayout2["SearchAuthorList"] = "SearchAuthorList";
  CellLayout2["SearchBookList"] = "SearchBookList";
  CellLayout2["SearchBookListWithTab"] = "SearchBookListWithTab";
  CellLayout2["SearchEventList"] = "SearchEventList";
  CellLayout2["SearchKeywordList"] = "SearchKeywordList";
  CellLayout2["SearchKeywordSectionList"] = "SearchKeywordSectionList";
  CellLayout2["SearchRoot"] = "SearchRoot";
  return CellLayout2;
})(CellLayout || {});
var CreateDeliveryInfoStatus = /* @__PURE__ */ ((CreateDeliveryInfoStatus2) => {
  CreateDeliveryInfoStatus2["Fail"] = "FAIL";
  CreateDeliveryInfoStatus2["Success"] = "SUCCESS";
  return CreateDeliveryInfoStatus2;
})(CreateDeliveryInfoStatus || {});
var DeliveryInfoCollectConsentStatus = /* @__PURE__ */ ((DeliveryInfoCollectConsentStatus2) => {
  DeliveryInfoCollectConsentStatus2["Fail"] = "FAIL";
  DeliveryInfoCollectConsentStatus2["Success"] = "SUCCESS";
  return DeliveryInfoCollectConsentStatus2;
})(DeliveryInfoCollectConsentStatus || {});
var DeliveryInfoCollectTargetStatus = /* @__PURE__ */ ((DeliveryInfoCollectTargetStatus2) => {
  DeliveryInfoCollectTargetStatus2["Fail"] = "FAIL";
  DeliveryInfoCollectTargetStatus2["Success"] = "SUCCESS";
  return DeliveryInfoCollectTargetStatus2;
})(DeliveryInfoCollectTargetStatus || {});
var DeviceType = /* @__PURE__ */ ((DeviceType2) => {
  DeviceType2["Desktop"] = "DESKTOP";
  DeviceType2["Mobile"] = "MOBILE";
  DeviceType2["Tablet"] = "TABLET";
  return DeviceType2;
})(DeviceType || {});
var DurationUnitType = /* @__PURE__ */ ((DurationUnitType2) => {
  DurationUnitType2["Day"] = "DAY";
  DurationUnitType2["Hour"] = "HOUR";
  DurationUnitType2["Minute"] = "MINUTE";
  DurationUnitType2["Month"] = "MONTH";
  DurationUnitType2["Second"] = "SECOND";
  return DurationUnitType2;
})(DurationUnitType || {});
var EventGenre = /* @__PURE__ */ ((EventGenre2) => {
  EventGenre2["Bl"] = "BL";
  EventGenre2["BlComic"] = "BL_COMIC";
  EventGenre2["BlNover"] = "BL_NOVER";
  EventGenre2["BlSeries"] = "BL_SERIES";
  EventGenre2["BlWebnovel"] = "BL_WEBNOVEL";
  EventGenre2["BlWebtoon"] = "BL_WEBTOON";
  EventGenre2["Comic"] = "COMIC";
  EventGenre2["ComicSeries"] = "COMIC_SERIES";
  EventGenre2["Fantasy"] = "FANTASY";
  EventGenre2["FantasySeries"] = "FANTASY_SERIES";
  EventGenre2["General"] = "GENERAL";
  EventGenre2["Romance"] = "ROMANCE";
  EventGenre2["RomanceFantasy"] = "ROMANCE_FANTASY";
  EventGenre2["RomanceFantasySeries"] = "ROMANCE_FANTASY_SERIES";
  EventGenre2["RomanceSeries"] = "ROMANCE_SERIES";
  EventGenre2["Webtoon"] = "WEBTOON";
  return EventGenre2;
})(EventGenre || {});
var EventGroupType = /* @__PURE__ */ ((EventGroupType2) => {
  EventGroupType2["Discount"] = "DISCOUNT";
  EventGroupType2["GiftPlus"] = "GIFT_PLUS";
  EventGroupType2["Normal"] = "NORMAL";
  EventGroupType2["PointLink"] = "POINT_LINK";
  return EventGroupType2;
})(EventGroupType || {});
var EventItemOrder = /* @__PURE__ */ ((EventItemOrder2) => {
  EventItemOrder2["Popularity"] = "POPULARITY";
  EventItemOrder2["PriceAsc"] = "PRICE_ASC";
  EventItemOrder2["PriceDesc"] = "PRICE_DESC";
  EventItemOrder2["Recommend"] = "RECOMMEND";
  EventItemOrder2["Sales"] = "SALES";
  EventItemOrder2["Title"] = "TITLE";
  return EventItemOrder2;
})(EventItemOrder || {});
var EventSubGroupViewType = /* @__PURE__ */ ((EventSubGroupViewType2) => {
  EventSubGroupViewType2["List"] = "LIST";
  EventSubGroupViewType2["Thumb"] = "THUMB";
  return EventSubGroupViewType2;
})(EventSubGroupViewType || {});
var EventType = /* @__PURE__ */ ((EventType2) => {
  EventType2["Default"] = "DEFAULT";
  EventType2["ImageOnly"] = "IMAGE_ONLY";
  EventType2["LinkRedirect"] = "LINK_REDIRECT";
  EventType2["NotificationReward"] = "NOTIFICATION_REWARD";
  EventType2["Unknown"] = "UNKNOWN";
  EventType2["Unrecognized"] = "UNRECOGNIZED";
  return EventType2;
})(EventType || {});
var ExtendedOwnershipType = /* @__PURE__ */ ((ExtendedOwnershipType2) => {
  ExtendedOwnershipType2["HardDeleted"] = "HARD_DELETED";
  ExtendedOwnershipType2["MySelectDeleted"] = "MY_SELECT_DELETED";
  ExtendedOwnershipType2["RentExpired"] = "RENT_EXPIRED";
  ExtendedOwnershipType2["SelectServiceEnded"] = "SELECT_SERVICE_ENDED";
  ExtendedOwnershipType2["SelectSubscriptionEnded"] = "SELECT_SUBSCRIPTION_ENDED";
  ExtendedOwnershipType2["Valid"] = "VALID";
  return ExtendedOwnershipType2;
})(ExtendedOwnershipType || {});
var FileFormat = /* @__PURE__ */ ((FileFormat2) => {
  FileFormat2["Bom"] = "BOM";
  FileFormat2["Epub"] = "EPUB";
  FileFormat2["Pdf"] = "PDF";
  FileFormat2["Webtoon"] = "WEBTOON";
  return FileFormat2;
})(FileFormat || {});
var FindIdStatus = /* @__PURE__ */ ((FindIdStatus2) => {
  FindIdStatus2["Fail"] = "FAIL";
  FindIdStatus2["Success"] = "SUCCESS";
  return FindIdStatus2;
})(FindIdStatus || {});
var FindPasswordStatus = /* @__PURE__ */ ((FindPasswordStatus2) => {
  FindPasswordStatus2["Fail"] = "FAIL";
  FindPasswordStatus2["Success"] = "SUCCESS";
  return FindPasswordStatus2;
})(FindPasswordStatus || {});
var Gender = /* @__PURE__ */ ((Gender2) => {
  Gender2["Female"] = "FEMALE";
  Gender2["Male"] = "MALE";
  return Gender2;
})(Gender || {});
var GridLayout = /* @__PURE__ */ ((GridLayout2) => {
  GridLayout2["AppMarketingBridge"] = "AppMarketingBridge";
  GridLayout2["BookDetailHome"] = "BookDetailHome";
  GridLayout2["Search"] = "Search";
  return GridLayout2;
})(GridLayout || {});
var GridType = /* @__PURE__ */ ((GridType2) => {
  GridType2["AppMarketingBridge"] = "AppMarketingBridge";
  GridType2["BookDetailHome"] = "BookDetailHome";
  GridType2["Search"] = "Search";
  return GridType2;
})(GridType || {});
var KeywordFinderGenre = /* @__PURE__ */ ((KeywordFinderGenre2) => {
  KeywordFinderGenre2["Bl"] = "BL";
  KeywordFinderGenre2["BlComic"] = "BL_COMIC";
  KeywordFinderGenre2["BlNovel"] = "BL_NOVEL";
  KeywordFinderGenre2["BlSerial"] = "BL_SERIAL";
  KeywordFinderGenre2["Comic"] = "COMIC";
  KeywordFinderGenre2["Fantasy"] = "FANTASY";
  KeywordFinderGenre2["FantasySerial"] = "FANTASY_SERIAL";
  KeywordFinderGenre2["General"] = "GENERAL";
  KeywordFinderGenre2["Lightnovel"] = "LIGHTNOVEL";
  KeywordFinderGenre2["Romance"] = "ROMANCE";
  KeywordFinderGenre2["RomanceSerial"] = "ROMANCE_SERIAL";
  KeywordFinderGenre2["Webtoon"] = "WEBTOON";
  return KeywordFinderGenre2;
})(KeywordFinderGenre || {});
var KeywordFinderOrder = /* @__PURE__ */ ((KeywordFinderOrder2) => {
  KeywordFinderOrder2["Popularity"] = "POPULARITY";
  KeywordFinderOrder2["Rating"] = "RATING";
  KeywordFinderOrder2["Recent"] = "RECENT";
  KeywordFinderOrder2["Review"] = "REVIEW";
  return KeywordFinderOrder2;
})(KeywordFinderOrder || {});
var ModifyDeliveryInfoStatus = /* @__PURE__ */ ((ModifyDeliveryInfoStatus2) => {
  ModifyDeliveryInfoStatus2["Fail"] = "FAIL";
  ModifyDeliveryInfoStatus2["Success"] = "SUCCESS";
  return ModifyDeliveryInfoStatus2;
})(ModifyDeliveryInfoStatus || {});
var ModifyNewBookNotificationUseStatus = /* @__PURE__ */ ((ModifyNewBookNotificationUseStatus2) => {
  ModifyNewBookNotificationUseStatus2["Fail"] = "FAIL";
  ModifyNewBookNotificationUseStatus2["Success"] = "SUCCESS";
  return ModifyNewBookNotificationUseStatus2;
})(ModifyNewBookNotificationUseStatus || {});
var NewReleaseOrder = /* @__PURE__ */ ((NewReleaseOrder2) => {
  NewReleaseOrder2["Popularity"] = "POPULARITY";
  NewReleaseOrder2["Recent"] = "RECENT";
  return NewReleaseOrder2;
})(NewReleaseOrder || {});
var OwnershipType = /* @__PURE__ */ ((OwnershipType2) => {
  OwnershipType2["Freerent"] = "FREERENT";
  OwnershipType2["Gift"] = "GIFT";
  OwnershipType2["Purchase"] = "PURCHASE";
  OwnershipType2["Rental"] = "RENTAL";
  OwnershipType2["Ridiselect"] = "RIDISELECT";
  OwnershipType2["Test"] = "TEST";
  return OwnershipType2;
})(OwnershipType || {});
var Period = /* @__PURE__ */ ((Period2) => {
  Period2["Daily"] = "DAILY";
  Period2["Monthly"] = "MONTHLY";
  Period2["Weekly"] = "WEEKLY";
  Period2["Yearly"] = "YEARLY";
  return Period2;
})(Period || {});
var Platform = /* @__PURE__ */ ((Platform2) => {
  Platform2["Android"] = "ANDROID";
  Platform2["Ios"] = "IOS";
  Platform2["OnepunOff"] = "ONEPUN_OFF";
  Platform2["OnepunOn"] = "ONEPUN_ON";
  Platform2["Web"] = "WEB";
  return Platform2;
})(Platform || {});
var RatingStar = /* @__PURE__ */ ((RatingStar2) => {
  RatingStar2["Five"] = "FIVE";
  RatingStar2["Four"] = "FOUR";
  RatingStar2["One"] = "ONE";
  RatingStar2["Three"] = "THREE";
  RatingStar2["Two"] = "TWO";
  return RatingStar2;
})(RatingStar || {});
var ReadNotificationStatus = /* @__PURE__ */ ((ReadNotificationStatus2) => {
  ReadNotificationStatus2["Fail"] = "FAIL";
  ReadNotificationStatus2["Success"] = "SUCCESS";
  return ReadNotificationStatus2;
})(ReadNotificationStatus || {});
var ReadRecordType = /* @__PURE__ */ ((ReadRecordType2) => {
  ReadRecordType2["Series"] = "SERIES";
  ReadRecordType2["SingleBook"] = "SINGLE_BOOK";
  return ReadRecordType2;
})(ReadRecordType || {});
var RecentReadFilterRangeType = /* @__PURE__ */ ((RecentReadFilterRangeType2) => {
  RecentReadFilterRangeType2["Category"] = "CATEGORY";
  RecentReadFilterRangeType2["Genre"] = "GENRE";
  return RecentReadFilterRangeType2;
})(RecentReadFilterRangeType || {});
var RecommendSimBy = /* @__PURE__ */ ((RecommendSimBy2) => {
  RecommendSimBy2["Purchase"] = "purchase";
  RecommendSimBy2["Select"] = "select";
  RecommendSimBy2["View"] = "view";
  return RecommendSimBy2;
})(RecommendSimBy || {});
var RemoveRecentReadsOption = /* @__PURE__ */ ((RemoveRecentReadsOption2) => {
  RemoveRecentReadsOption2["All"] = "ALL";
  RemoveRecentReadsOption2["Exclude"] = "EXCLUDE";
  RemoveRecentReadsOption2["Include"] = "INCLUDE";
  return RemoveRecentReadsOption2;
})(RemoveRecentReadsOption || {});
var RemoveRecentReadsStatus = /* @__PURE__ */ ((RemoveRecentReadsStatus2) => {
  RemoveRecentReadsStatus2["Fail"] = "FAIL";
  RemoveRecentReadsStatus2["Success"] = "SUCCESS";
  return RemoveRecentReadsStatus2;
})(RemoveRecentReadsStatus || {});
var RemoveUserInterestBookOption = /* @__PURE__ */ ((RemoveUserInterestBookOption2) => {
  RemoveUserInterestBookOption2["All"] = "ALL";
  RemoveUserInterestBookOption2["Exclude"] = "EXCLUDE";
  RemoveUserInterestBookOption2["Include"] = "INCLUDE";
  return RemoveUserInterestBookOption2;
})(RemoveUserInterestBookOption || {});
var RemoveUserInterestBookResponseStatus = /* @__PURE__ */ ((RemoveUserInterestBookResponseStatus2) => {
  RemoveUserInterestBookResponseStatus2["Fail"] = "FAIL";
  RemoveUserInterestBookResponseStatus2["Success"] = "SUCCESS";
  return RemoveUserInterestBookResponseStatus2;
})(RemoveUserInterestBookResponseStatus || {});
var RemoveWishlistStatus = /* @__PURE__ */ ((RemoveWishlistStatus2) => {
  RemoveWishlistStatus2["Success"] = "SUCCESS";
  return RemoveWishlistStatus2;
})(RemoveWishlistStatus || {});
var RidiAwardGenrePropertyType = /* @__PURE__ */ ((RidiAwardGenrePropertyType2) => {
  RidiAwardGenrePropertyType2["ActiveUrl"] = "ACTIVE_URL";
  RidiAwardGenrePropertyType2["HighlightUrl"] = "HIGHLIGHT_URL";
  RidiAwardGenrePropertyType2["InactiveUrl"] = "INACTIVE_URL";
  RidiAwardGenrePropertyType2["PrimaryColor"] = "PRIMARY_COLOR";
  RidiAwardGenrePropertyType2["ShareUrl"] = "SHARE_URL";
  return RidiAwardGenrePropertyType2;
})(RidiAwardGenrePropertyType || {});
var RidiAwardGenreUserStatusType = /* @__PURE__ */ ((RidiAwardGenreUserStatusType2) => {
  RidiAwardGenreUserStatusType2["AlreadyVoted"] = "ALREADY_VOTED";
  RidiAwardGenreUserStatusType2["Valid"] = "VALID";
  return RidiAwardGenreUserStatusType2;
})(RidiAwardGenreUserStatusType || {});
var RidiAwardUserStatusType = /* @__PURE__ */ ((RidiAwardUserStatusType2) => {
  RidiAwardUserStatusType2["NotEligible"] = "NOT_ELIGIBLE";
  RidiAwardUserStatusType2["Valid"] = "VALID";
  return RidiAwardUserStatusType2;
})(RidiAwardUserStatusType || {});
var SearchOrder = /* @__PURE__ */ ((SearchOrder2) => {
  SearchOrder2["Grade"] = "GRADE";
  SearchOrder2["Price"] = "PRICE";
  SearchOrder2["PriceDesc"] = "PRICE_DESC";
  SearchOrder2["PriceForEvent"] = "PRICE_FOR_EVENT";
  SearchOrder2["PriceForEventDesc"] = "PRICE_FOR_EVENT_DESC";
  SearchOrder2["Recent"] = "RECENT";
  SearchOrder2["ReviewCnt"] = "REVIEW_CNT";
  SearchOrder2["Sales"] = "SALES";
  SearchOrder2["Score"] = "SCORE";
  SearchOrder2["Title"] = "TITLE";
  SearchOrder2["TitleExact"] = "TITLE_EXACT";
  return SearchOrder2;
})(SearchOrder || {});
var SearchSite = /* @__PURE__ */ ((SearchSite2) => {
  SearchSite2["Cps"] = "CPS";
  SearchSite2["RidiSelect"] = "RIDI_SELECT";
  SearchSite2["RidiStore"] = "RIDI_STORE";
  return SearchSite2;
})(SearchSite || {});
var SearchWhat = /* @__PURE__ */ ((SearchWhat2) => {
  SearchWhat2["AuthorBook"] = "AUTHOR_BOOK";
  SearchWhat2["Base"] = "BASE";
  SearchWhat2["Event"] = "EVENT";
  SearchWhat2["Instant"] = "INSTANT";
  SearchWhat2["InApp"] = "IN_APP";
  SearchWhat2["Publisher"] = "PUBLISHER";
  SearchWhat2["ReadingNote"] = "READING_NOTE";
  SearchWhat2["Shelf"] = "SHELF";
  SearchWhat2["Tag"] = "TAG";
  return SearchWhat2;
})(SearchWhat || {});
var SearchWhere = /* @__PURE__ */ ((SearchWhere2) => {
  SearchWhere2["Author"] = "AUTHOR";
  SearchWhere2["Book"] = "BOOK";
  return SearchWhere2;
})(SearchWhere || {});
var SetBookOption = /* @__PURE__ */ ((SetBookOption2) => {
  SetBookOption2["ExcludeSetBook"] = "EXCLUDE_SET_BOOK";
  SetBookOption2["None"] = "NONE";
  SetBookOption2["OnlySetBook"] = "ONLY_SET_BOOK";
  return SetBookOption2;
})(SetBookOption || {});
var SetPasswordStatus = /* @__PURE__ */ ((SetPasswordStatus2) => {
  SetPasswordStatus2["Fail"] = "FAIL";
  SetPasswordStatus2["Success"] = "SUCCESS";
  return SetPasswordStatus2;
})(SetPasswordStatus || {});
var SocialProvider = /* @__PURE__ */ ((SocialProvider2) => {
  SocialProvider2["Apple"] = "APPLE";
  SocialProvider2["Google"] = "GOOGLE";
  SocialProvider2["Kakao"] = "KAKAO";
  SocialProvider2["Naver"] = "NAVER";
  return SocialProvider2;
})(SocialProvider || {});
var UserInterestBookOrderFilter = /* @__PURE__ */ ((UserInterestBookOrderFilter2) => {
  UserInterestBookOrderFilter2["RegDate"] = "REG_DATE";
  UserInterestBookOrderFilter2["Title"] = "TITLE";
  UserInterestBookOrderFilter2["Update"] = "UPDATE";
  return UserInterestBookOrderFilter2;
})(UserInterestBookOrderFilter || {});
var UserInterestBookType = /* @__PURE__ */ ((UserInterestBookType2) => {
  UserInterestBookType2["Series"] = "SERIES";
  UserInterestBookType2["SingleBook"] = "SINGLE_BOOK";
  return UserInterestBookType2;
})(UserInterestBookType || {});
var UserReviewStatusType = /* @__PURE__ */ ((UserReviewStatusType2) => {
  UserReviewStatusType2["InvisibleByAdmin"] = "INVISIBLE_BY_ADMIN";
  UserReviewStatusType2["InvisibleByReport"] = "INVISIBLE_BY_REPORT";
  UserReviewStatusType2["InvisibleByUser"] = "INVISIBLE_BY_USER";
  UserReviewStatusType2["SpoilerByAdmin"] = "SPOILER_BY_ADMIN";
  UserReviewStatusType2["SpoilerByUser"] = "SPOILER_BY_USER";
  UserReviewStatusType2["Visible"] = "VISIBLE";
  return UserReviewStatusType2;
})(UserReviewStatusType || {});
var WishlistOrder = /* @__PURE__ */ ((WishlistOrder2) => {
  WishlistOrder2["DiscountRate"] = "DISCOUNT_RATE";
  WishlistOrder2["Latest"] = "LATEST";
  WishlistOrder2["LowestPrice"] = "LOWEST_PRICE";
  WishlistOrder2["Popularity"] = "POPULARITY";
  return WishlistOrder2;
})(WishlistOrder || {});
var AddUserInterestBookResponseStatus = /* @__PURE__ */ ((AddUserInterestBookResponseStatus2) => {
  AddUserInterestBookResponseStatus2["Fail"] = "FAIL";
  AddUserInterestBookResponseStatus2["Success"] = "SUCCESS";
  return AddUserInterestBookResponseStatus2;
})(AddUserInterestBookResponseStatus || {});
const BooksDetailAsideBannerItemFragmentDoc = "\n    fragment BooksDetailAsideBannerItem on Banner {\n  id\n  imageUrl\n  link\n  title\n}\n    ";
const BooksDetailAsideBestSellerItemFragmentDoc = "\n    fragment BooksDetailAsideBestSellerItem on BestsellerBook {\n  book {\n    id\n    title {\n      main\n    }\n    series {\n      id\n      title\n    }\n  }\n}\n    ";
const BooksDetailMetadataCategoryFragmentDoc = "\n    fragment BooksDetailMetadataCategory on Category {\n  id\n  priority\n  isSeries\n  genre\n  name\n}\n    ";
const IpGoodsFragmentDoc = "\n    fragment IpGoods on IpGoods {\n  products {\n    id\n    link\n    name\n    subname\n    thumbnail\n  }\n  seller {\n    id\n    link\n    name\n    thumbnail\n  }\n}\n    ";
const RelatedSeriesInfoFragmentDoc = "\n    fragment RelatedSeriesInfo on RelatedSeriesInfo {\n  html\n  title\n}\n    ";
const EventDetailBookLandscapeDataFragmentDoc = "\n    fragment EventDetailBookLandscapeData on Book {\n  id\n  introduction {\n    description\n  }\n  publicationInfo {\n    name\n  }\n  categories {\n    name\n    isSeries\n  }\n  priceInfo {\n    rental {\n      fullPrice\n      sellingPrice\n    }\n    purchase {\n      fullPrice\n      sellingPrice\n    }\n  }\n  series {\n    priceInfo {\n      rental {\n        minPriceNonZero\n        minPrice\n      }\n      purchase {\n        minPriceNonZero\n        minPrice\n      }\n      rentalAll {\n        fullPrice\n        sellingPrice\n        maxDiscountRate\n        minDiscountRate\n        discountRate\n      }\n      purchaseAll {\n        fullPrice\n        sellingPrice\n        maxDiscountRate\n        minDiscountRate\n        discountRate\n      }\n    }\n  }\n}\n    ";
const EventDetailGroupMetadataFragmentDoc = "\n    fragment EventDetailGroupMetadata on EventGroup {\n  id\n  purchaseTotalNotice\n  uiOption {\n    usePurchaseTotal\n    useBuyTotal\n    useRentTotal\n    useReviewTotal\n    useTabUi\n    useSearch\n    useOrderAndFilter\n  }\n  tabs {\n    id\n    itemCount\n    name\n    order\n  }\n  subGroups {\n    id\n    name\n    tabId\n    order\n    viewType\n    totalItemCount\n  }\n}\n    ";
const BookBadgeFragmentDoc = "\n    fragment BookBadge on Badge {\n  backgroundColors {\n    light\n    dark\n  }\n  text\n  type\n  urls\n}\n    ";
const BookBaseFragmentDoc = "\n    fragment BookBase on Book {\n  authors {\n    id\n    name\n    role\n  }\n  categories {\n    name\n    genre\n    isSeries\n  }\n  id\n  introduction {\n    description\n  }\n  isAdultOnly\n  isOriginal\n  isPreExclusive\n  priceInfo {\n    purchase {\n      fullPrice\n      sellingPrice\n    }\n    rental {\n      fullPrice\n      sellingPrice\n    }\n  }\n  publicationInfo {\n    name\n  }\n  ratings {\n    count\n    rating\n  }\n  series {\n    id\n    freeEpisodeCountInfo {\n      purchase\n      rental\n    }\n    isCompleted\n    priceInfo {\n      purchase {\n        maxPrice\n        minPrice\n        minPriceNonZero\n      }\n      purchaseAll {\n        fullPrice\n        sellingPrice\n        discountRate\n        maxDiscountRate\n        minDiscountRate\n      }\n      rental {\n        maxPrice\n        minPrice\n        minPriceNonZero\n      }\n      rentalAll {\n        fullPrice\n        sellingPrice\n        discountRate\n        maxDiscountRate\n        minDiscountRate\n      }\n    }\n    thumbnail {\n      large\n      small\n      xxlarge\n    }\n    title\n    totalEpisodeCount\n    unit\n    isEntireSeriesPreExclusive\n    isNewEpisodePreExclusive\n  }\n  set {\n    totalCount\n  }\n  title {\n    main\n  }\n  style {\n    layout\n  }\n}\n    ";
const BookShellFragmentDoc = "\n    fragment BookShell on BookShell {\n  badges {\n    ...BookBadge\n  }\n  book {\n    ...BookBase\n  }\n}\n    ".concat(BookBadgeFragmentDoc, "\n").concat(BookBaseFragmentDoc);
const Portrait3InfoBookBaseFragmentDoc = "\n    fragment Portrait3InfoBookBase on Book {\n  authors {\n    id\n    name\n    role\n  }\n  categories {\n    isSeries\n  }\n  id\n  isAdultOnly\n  isOriginal\n  isPreExclusive\n  title {\n    main\n  }\n  ratings {\n    count\n    rating\n  }\n  series {\n    thumbnail {\n      large\n      small\n      xxlarge\n    }\n    title\n    unit\n    isEntireSeriesPreExclusive\n    isNewEpisodePreExclusive\n  }\n  set {\n    totalCount\n  }\n  style {\n    layout\n  }\n}\n    ";
const Portrait3InfoBookShellFragmentDoc = "\n    fragment Portrait3InfoBookShell on BookShell {\n  id\n  book {\n    ...Portrait3InfoBookBase\n  }\n  badges {\n    ...BookBadge\n  }\n}\n    ".concat(Portrait3InfoBookBaseFragmentDoc, "\n").concat(BookBadgeFragmentDoc);
const LandscapeBookBaseFragmentDoc = "\n    fragment LandscapeBookBase on Book {\n  ...BookBase\n}\n    ".concat(BookBaseFragmentDoc);
const LandscapeBookShellFragmentDoc = "\n    fragment LandscapeBookShell on BookShell {\n  id\n  badges {\n    ...BookBadge\n  }\n  book {\n    ...BookBase\n  }\n}\n    ".concat(BookBadgeFragmentDoc, "\n").concat(BookBaseFragmentDoc);
const KeywordFinderBookShellFragmentDoc = "\n    fragment KeywordFinderBookShell on BookShell {\n  badges {\n    ...BookBadge\n  }\n  book {\n    ...BookBase\n  }\n}\n    ".concat(BookBadgeFragmentDoc, "\n").concat(BookBaseFragmentDoc);
const KeywordFinderTagFragmentDoc = "\n    fragment KeywordFinderTag on Tag {\n  id\n  name\n}\n    ";
const KeywordFinderSetKeywordFragmentDoc = "\n    fragment KeywordFinderSetKeyword on KeywordFinderKeyword {\n  id\n  tagId\n  keywordOption\n  tag {\n    ...KeywordFinderTag\n  }\n}\n    ".concat(KeywordFinderTagFragmentDoc);
const KeywordFinderSetGroupFragmentDoc = "\n    fragment KeywordFinderSetGroup on KeywordFinderGroup {\n  id\n  title\n  listOrder\n  visible\n  keywords {\n    ...KeywordFinderSetKeyword\n  }\n}\n    ".concat(KeywordFinderSetKeywordFragmentDoc);
const KeywordFinderSetFragmentDoc = "\n    fragment KeywordFinderSet on KeywordFinderGroupSet {\n  id\n  title\n  visible\n  groups {\n    ...KeywordFinderSetGroup\n  }\n}\n    ".concat(KeywordFinderSetGroupFragmentDoc);
const AddDeliveryInfoCollectConsentDocument = "\n    mutation AddDeliveryInfoCollectConsent {\n  addDeliveryInfoCollectConsent {\n    message\n    status\n  }\n}\n    ";
const useAddDeliveryInfoCollectConsentMutation = (options) => {
  return useMutation(
    ["AddDeliveryInfoCollectConsent"],
    (variables) => fetcher(
      AddDeliveryInfoCollectConsentDocument,
      variables
    )(),
    options
  );
};
useAddDeliveryInfoCollectConsentMutation.getKey = () => ["AddDeliveryInfoCollectConsent"];
useAddDeliveryInfoCollectConsentMutation.fetcher = (variables, options) => fetcher(
  AddDeliveryInfoCollectConsentDocument,
  variables,
  options
);
const CreateDeliveryInfoDocument = "\n    mutation CreateDeliveryInfo($deliveryInfo: UserDeliverInfo!) {\n  createDeliveryInfo(deliveryInfo: $deliveryInfo) {\n    message\n    status\n  }\n}\n    ";
const useCreateDeliveryInfoMutation = (options) => {
  return useMutation(
    ["CreateDeliveryInfo"],
    (variables) => fetcher(CreateDeliveryInfoDocument, variables)(),
    options
  );
};
useCreateDeliveryInfoMutation.getKey = () => ["CreateDeliveryInfo"];
useCreateDeliveryInfoMutation.fetcher = (variables, options) => fetcher(
  CreateDeliveryInfoDocument,
  variables,
  options
);
const ModifyDeliveryInfoDocument = "\n    mutation ModifyDeliveryInfo($deliveryInfo: ModifyingUserDeliveryInfo!) {\n  modifyDeliveryInfo(deliveryInfo: $deliveryInfo) {\n    message\n    status\n  }\n}\n    ";
const useModifyDeliveryInfoMutation = (options) => {
  return useMutation(
    ["ModifyDeliveryInfo"],
    (variables) => fetcher(ModifyDeliveryInfoDocument, variables)(),
    options
  );
};
useModifyDeliveryInfoMutation.getKey = () => ["ModifyDeliveryInfo"];
useModifyDeliveryInfoMutation.fetcher = (variables, options) => fetcher(
  ModifyDeliveryInfoDocument,
  variables,
  options
);
const RemoveDeliveryInfoCollectConsentDocument = "\n    mutation RemoveDeliveryInfoCollectConsent {\n  removeDeliveryInfoCollectConsent {\n    message\n    status\n  }\n}\n    ";
const useRemoveDeliveryInfoCollectConsentMutation = (options) => {
  return useMutation(
    ["RemoveDeliveryInfoCollectConsent"],
    (variables) => fetcher(
      RemoveDeliveryInfoCollectConsentDocument,
      variables
    )(),
    options
  );
};
useRemoveDeliveryInfoCollectConsentMutation.getKey = () => ["RemoveDeliveryInfoCollectConsent"];
useRemoveDeliveryInfoCollectConsentMutation.fetcher = (variables, options) => fetcher(
  RemoveDeliveryInfoCollectConsentDocument,
  variables,
  options
);
const AddUserInterestBookDocument = "\n    mutation AddUserInterestBook($bookId: String!) {\n  addUserInterestBook(bookId: $bookId) {\n    message\n    status\n    genre\n  }\n}\n    ";
const useAddUserInterestBookMutation = (options) => {
  return useMutation(
    ["AddUserInterestBook"],
    (variables) => fetcher(
      AddUserInterestBookDocument,
      variables
    )(),
    options
  );
};
useAddUserInterestBookMutation.getKey = () => ["AddUserInterestBook"];
useAddUserInterestBookMutation.fetcher = (variables, options) => fetcher(
  AddUserInterestBookDocument,
  variables,
  options
);
const RemoveUserInterestBookDocument = "\n    mutation RemoveUserInterestBook($bookIds: [String!]!, $categoryIncludes: [Int!]!, $option: RemoveUserInterestBookOption!) {\n  removeUserInterestBook(\n    bookIds: $bookIds\n    categoryIncludes: $categoryIncludes\n    option: $option\n  ) {\n    message\n    status\n  }\n}\n    ";
const useRemoveUserInterestBookMutation = (options) => {
  return useMutation(
    ["RemoveUserInterestBook"],
    (variables) => fetcher(
      RemoveUserInterestBookDocument,
      variables
    )(),
    options
  );
};
useRemoveUserInterestBookMutation.getKey = () => ["RemoveUserInterestBook"];
useRemoveUserInterestBookMutation.fetcher = (variables, options) => fetcher(
  RemoveUserInterestBookDocument,
  variables,
  options
);
const ModifyNewBookNotificationUseDocument = "\n    mutation ModifyNewBookNotificationUse($bookId: String!, $isInUse: Boolean!) {\n  modifyNewBookNotificationUse(bookId: $bookId, isInUse: $isInUse) {\n    message\n    status\n  }\n}\n    ";
const useModifyNewBookNotificationUseMutation = (options) => {
  return useMutation(
    ["ModifyNewBookNotificationUse"],
    (variables) => fetcher(
      ModifyNewBookNotificationUseDocument,
      variables
    )(),
    options
  );
};
useModifyNewBookNotificationUseMutation.getKey = () => ["ModifyNewBookNotificationUse"];
useModifyNewBookNotificationUseMutation.fetcher = (variables, options) => fetcher(
  ModifyNewBookNotificationUseDocument,
  variables,
  options
);
const ReadNotificationDocument = "\n    mutation ReadNotification($tabId: Int!) {\n  readNotification(tabId: $tabId) {\n    status\n    message\n  }\n}\n    ";
const useReadNotificationMutation = (options) => {
  return useMutation(
    ["ReadNotification"],
    (variables) => fetcher(ReadNotificationDocument, variables)(),
    options
  );
};
useReadNotificationMutation.getKey = () => ["ReadNotification"];
useReadNotificationMutation.fetcher = (variables, options) => fetcher(ReadNotificationDocument, variables, options);
const AiRecommendationDocument = "\n    query AiRecommendation($adultOption: AdultOption!, $genre: String!, $pageLimitInput: PageLimitInput!) {\n  aiRecommendedBooks(\n    adultOption: $adultOption\n    genre: $genre\n    pageLimitInput: $pageLimitInput\n  ) {\n    title {\n      userId\n      postfix\n    }\n    items {\n      bookShell {\n        ...BookShell\n      }\n    }\n    pagination {\n      ... on PageLimitOutput {\n        offset\n        hasMore\n      }\n    }\n    totalItemCount\n  }\n}\n    ".concat(BookShellFragmentDoc);
const useAiRecommendationQuery = (variables, options) => {
  return useQuery(
    ["AiRecommendation", variables],
    fetcher(AiRecommendationDocument, variables),
    options
  );
};
useAiRecommendationQuery.getKey = (variables) => ["AiRecommendation", variables];
useAiRecommendationQuery.fetcher = (variables, options) => fetcher(AiRecommendationDocument, variables, options);
const BestSellersDocument = "\n    query BestSellers($period: BestsellerPeriod!, $categoryIncludes: [Int!]!, $adultOption: AdultOption!, $setBookOption: SetBookOption!, $onlyRentAvailable: Boolean!, $pageLimitInput: PageLimitInput!, $seriesCompleted: Boolean) {\n  bestsellers(\n    period: $period\n    categoryIncludes: $categoryIncludes\n    adultOption: $adultOption\n    setBookOption: $setBookOption\n    onlyRentAvailable: $onlyRentAvailable\n    pageLimitInput: $pageLimitInput\n    seriesCompleted: $seriesCompleted\n  ) {\n    items {\n      badges {\n        ...BookBadge\n      }\n      book {\n        ...BookBase\n      }\n    }\n    pagination {\n      ... on PageLimitOutput {\n        offset\n      }\n    }\n    totalItemCount\n  }\n}\n    ".concat(BookBadgeFragmentDoc, "\n").concat(BookBaseFragmentDoc);
const useBestSellersQuery = (variables, options) => {
  return useQuery(
    ["BestSellers", variables],
    fetcher(BestSellersDocument, variables),
    options
  );
};
useBestSellersQuery.getKey = (variables) => ["BestSellers", variables];
useBestSellersQuery.fetcher = (variables, options) => fetcher(BestSellersDocument, variables, options);
const RecommendBestSellersDocument = "\n    query RecommendBestSellers($period: BestsellerPeriod!, $categoryIncludes: [Int!]!, $adultOption: AdultOption!, $setBookOption: SetBookOption!, $onlyRentAvailable: Boolean!, $pageLimitInput: PageLimitInput!) {\n  bestsellers(\n    period: $period\n    categoryIncludes: $categoryIncludes\n    adultOption: $adultOption\n    setBookOption: $setBookOption\n    onlyRentAvailable: $onlyRentAvailable\n    pageLimitInput: $pageLimitInput\n  ) {\n    recommendItem {\n      badges {\n        ...BookBadge\n      }\n      book {\n        ...BookBase\n      }\n    }\n  }\n}\n    ".concat(BookBadgeFragmentDoc, "\n").concat(BookBaseFragmentDoc);
const useRecommendBestSellersQuery = (variables, options) => {
  return useQuery(
    ["RecommendBestSellers", variables],
    fetcher(RecommendBestSellersDocument, variables),
    options
  );
};
useRecommendBestSellersQuery.getKey = (variables) => [
  "RecommendBestSellers",
  variables
];
useRecommendBestSellersQuery.fetcher = (variables, options) => fetcher(
  RecommendBestSellersDocument,
  variables,
  options
);
const BooksDetailAsideDocument = "\n    query BooksDetailAside($categoryId: Int!) {\n  asideBanners(categoryId: $categoryId) {\n    top {\n      ...BooksDetailAsideBannerItem\n    }\n    bottom {\n      ...BooksDetailAsideBannerItem\n    }\n  }\n  bestsellers(\n    period: WEEKLY\n    categoryIncludes: [$categoryId]\n    adultOption: NONE\n    setBookOption: NONE\n    onlyRentAvailable: false\n    pageLimitInput: {page: 1, limit: 10}\n  ) {\n    items {\n      ...BooksDetailAsideBestSellerItem\n    }\n  }\n}\n    ".concat(BooksDetailAsideBannerItemFragmentDoc, "\n").concat(BooksDetailAsideBestSellerItemFragmentDoc);
const useBooksDetailAsideQuery = (variables, options) => {
  return useQuery(
    ["BooksDetailAside", variables],
    fetcher(BooksDetailAsideDocument, variables),
    options
  );
};
useBooksDetailAsideQuery.getKey = (variables) => ["BooksDetailAside", variables];
useBooksDetailAsideQuery.fetcher = (variables, options) => fetcher(BooksDetailAsideDocument, variables, options);
const BooksDetailMetadataDocument = "\n    query BooksDetailMetadata($bookId: String!) {\n  book(bookId: $bookId) {\n    categories {\n      ...BooksDetailMetadataCategory\n    }\n  }\n}\n    ".concat(BooksDetailMetadataCategoryFragmentDoc);
const useBooksDetailMetadataQuery = (variables, options) => {
  return useQuery(
    ["BooksDetailMetadata", variables],
    fetcher(BooksDetailMetadataDocument, variables),
    options
  );
};
useBooksDetailMetadataQuery.getKey = (variables) => [
  "BooksDetailMetadata",
  variables
];
useBooksDetailMetadataQuery.fetcher = (variables, options) => fetcher(BooksDetailMetadataDocument, variables, options);
const BooksDetailSectionsDocument = "\n    query BooksDetailSections($bookId: String!) {\n  ipGoodsSection(bookId: $bookId) {\n    ...IpGoods\n  }\n  relatedSeriesInfoSection(bookId: $bookId) {\n    ...RelatedSeriesInfo\n  }\n}\n    ".concat(IpGoodsFragmentDoc, "\n").concat(RelatedSeriesInfoFragmentDoc);
const useBooksDetailSectionsQuery = (variables, options) => {
  return useQuery(
    ["BooksDetailSections", variables],
    fetcher(BooksDetailSectionsDocument, variables),
    options
  );
};
useBooksDetailSectionsQuery.getKey = (variables) => [
  "BooksDetailSections",
  variables
];
useBooksDetailSectionsQuery.fetcher = (variables, options) => fetcher(BooksDetailSectionsDocument, variables, options);
const DeliveryInfoDocument = "\n    query DeliveryInfo($setBookId: String!) {\n  deliveryInfo(setBookId: $setBookId) {\n    deliveryAddress {\n      address\n      detailedAddress\n      zipCode\n    }\n    enableModificiation\n    receiverName\n    receiverPhone\n    setBookId\n    setBookTitle\n    trackingInfo {\n      courier\n      productName\n      shipmentStartDate\n      trackingNumber\n      trackingUrl\n    }\n    purchaseDate\n  }\n}\n    ";
const useDeliveryInfoQuery = (variables, options) => {
  return useQuery(
    ["DeliveryInfo", variables],
    fetcher(DeliveryInfoDocument, variables),
    options
  );
};
useDeliveryInfoQuery.getKey = (variables) => ["DeliveryInfo", variables];
useDeliveryInfoQuery.fetcher = (variables, options) => fetcher(DeliveryInfoDocument, variables, options);
const DeliveryInfoCollectTargetDocument = "\n    query DeliveryInfoCollectTarget {\n  deliveryInfoCollectTarget {\n    collectDeliveryInfoConsent\n    isTarget\n    message\n    status\n  }\n}\n    ";
const useDeliveryInfoCollectTargetQuery = (variables, options) => {
  return useQuery(
    variables === void 0 ? ["DeliveryInfoCollectTarget"] : ["DeliveryInfoCollectTarget", variables],
    fetcher(
      DeliveryInfoCollectTargetDocument,
      variables
    ),
    options
  );
};
useDeliveryInfoCollectTargetQuery.getKey = (variables) => variables === void 0 ? ["DeliveryInfoCollectTarget"] : ["DeliveryInfoCollectTarget", variables];
useDeliveryInfoCollectTargetQuery.fetcher = (variables, options) => fetcher(
  DeliveryInfoCollectTargetDocument,
  variables,
  options
);
const DeliveryInfosDocument = "\n    query DeliveryInfos {\n  deliveryInfos {\n    deliveryAddress {\n      address\n      detailedAddress\n      zipCode\n    }\n    enableModificiation\n    receiverName\n    receiverPhone\n    setBookId\n    setBookTitle\n    trackingInfo {\n      courier\n      productName\n      shipmentStartDate\n      trackingNumber\n      trackingUrl\n    }\n    purchaseDate\n  }\n}\n    ";
const useDeliveryInfosQuery = (variables, options) => {
  return useQuery(
    variables === void 0 ? ["DeliveryInfos"] : ["DeliveryInfos", variables],
    fetcher(DeliveryInfosDocument, variables),
    options
  );
};
useDeliveryInfosQuery.getKey = (variables) => variables === void 0 ? ["DeliveryInfos"] : ["DeliveryInfos", variables];
useDeliveryInfosQuery.fetcher = (variables, options) => fetcher(DeliveryInfosDocument, variables, options);
const EventDetailBookLandscapeDocument = "\n    query eventDetailBookLandscape($bookIds: [String!]!) {\n  books(bookIds: $bookIds) {\n    ...EventDetailBookLandscapeData\n  }\n}\n    ".concat(EventDetailBookLandscapeDataFragmentDoc);
const useEventDetailBookLandscapeQuery = (variables, options) => {
  return useQuery(
    ["eventDetailBookLandscape", variables],
    fetcher(
      EventDetailBookLandscapeDocument,
      variables
    ),
    options
  );
};
useEventDetailBookLandscapeQuery.getKey = (variables) => [
  "eventDetailBookLandscape",
  variables
];
useEventDetailBookLandscapeQuery.fetcher = (variables, options) => fetcher(
  EventDetailBookLandscapeDocument,
  variables,
  options
);
const EventDetailEventDocument = "\n    query EventDetailEvent($eventId: Int!) {\n  event(eventId: $eventId) {\n    id\n    name\n    groups {\n      id\n      tabs {\n        id\n        name\n      }\n      subGroups {\n        id\n        name\n        tabId\n        order\n        viewType\n        items {\n          id\n          bookShell {\n            rentable\n            book {\n              id\n              title {\n                main\n              }\n              authors {\n                name\n                id\n                role\n              }\n              categories {\n                isSeries\n              }\n              isAdultOnly\n              isOriginal\n              priceInfo {\n                rental {\n                  fullPrice\n                  sellingPrice\n                }\n                purchase {\n                  fullPrice\n                  sellingPrice\n                }\n              }\n              ratings {\n                rating\n                count\n              }\n              series {\n                id\n                freeEpisodeCountInfo {\n                  purchase\n                  rental\n                }\n                isCompleted\n                priceInfo {\n                  rental {\n                    minPriceNonZero\n                    minPrice\n                  }\n                  purchase {\n                    minPriceNonZero\n                    minPrice\n                  }\n                }\n                totalEpisodeCount\n                title\n                unit\n              }\n              set {\n                totalCount\n              }\n            }\n            badges {\n              text\n              backgroundColors {\n                light\n                dark\n              }\n              urls\n              type\n            }\n            eventPageCover {\n              small\n              large\n              xxlarge\n              originalSize {\n                width\n                height\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n    ";
const useEventDetailEventQuery = (variables, options) => {
  return useQuery(
    ["EventDetailEvent", variables],
    fetcher(EventDetailEventDocument, variables),
    options
  );
};
useEventDetailEventQuery.getKey = (variables) => ["EventDetailEvent", variables];
useEventDetailEventQuery.fetcher = (variables, options) => fetcher(EventDetailEventDocument, variables, options);
const EventDetailMetadataDocument = "\n    query EventDetailMetadata($eventId: Int!) {\n  event(eventId: $eventId, order: POPULARITY) {\n    id\n    name\n    uiOption {\n      useCart\n    }\n    groups {\n      ...EventDetailGroupMetadata\n    }\n    isMarkdown\n  }\n}\n    ".concat(EventDetailGroupMetadataFragmentDoc);
const useEventDetailMetadataQuery = (variables, options) => {
  return useQuery(
    ["EventDetailMetadata", variables],
    fetcher(EventDetailMetadataDocument, variables),
    options
  );
};
useEventDetailMetadataQuery.getKey = (variables) => [
  "EventDetailMetadata",
  variables
];
useEventDetailMetadataQuery.fetcher = (variables, options) => fetcher(EventDetailMetadataDocument, variables, options);
const EventDetailOwnershipsDocument = "\n    query EventDetailOwnerships($eventId: Int!) {\n  eventOwnership(eventId: $eventId) {\n    ownerships {\n      bookId\n      purchasable\n    }\n  }\n}\n    ";
const useEventDetailOwnershipsQuery = (variables, options) => {
  return useQuery(
    ["EventDetailOwnerships", variables],
    fetcher(EventDetailOwnershipsDocument, variables),
    options
  );
};
useEventDetailOwnershipsQuery.getKey = (variables) => [
  "EventDetailOwnerships",
  variables
];
useEventDetailOwnershipsQuery.fetcher = (variables, options) => fetcher(
  EventDetailOwnershipsDocument,
  variables,
  options
);
const EventDetailSearchDocument = "\n    query EventDetailSearch($eventId: Int!, $searchKeyword: String!, $filterInput: EventSearchFilterInput, $pageLimitInput: PageLimitInput) {\n  eventSearch(\n    keyword: $searchKeyword\n    eventId: $eventId\n    filterInput: $filterInput\n    pageLimitInput: $pageLimitInput\n  ) {\n    totalItemCount\n    books {\n      rentable\n      book {\n        id\n        title {\n          main\n        }\n        authors {\n          name\n          id\n          role\n        }\n        categories {\n          isSeries\n        }\n        isAdultOnly\n        isOriginal\n        priceInfo {\n          rental {\n            fullPrice\n            sellingPrice\n          }\n          purchase {\n            fullPrice\n            sellingPrice\n          }\n        }\n        ratings {\n          rating\n          count\n        }\n        series {\n          id\n          freeEpisodeCountInfo {\n            purchase\n            rental\n          }\n          isCompleted\n          priceInfo {\n            rental {\n              minPriceNonZero\n              minPrice\n            }\n            purchase {\n              minPriceNonZero\n              minPrice\n            }\n          }\n          totalEpisodeCount\n          title\n          unit\n        }\n        set {\n          totalCount\n        }\n      }\n      badges {\n        text\n        backgroundColors {\n          light\n          dark\n        }\n        urls\n        type\n      }\n      eventPageCover {\n        small\n        large\n        xxlarge\n        originalSize {\n          width\n          height\n        }\n      }\n    }\n  }\n}\n    ";
const useEventDetailSearchQuery = (variables, options) => {
  return useQuery(
    ["EventDetailSearch", variables],
    fetcher(EventDetailSearchDocument, variables),
    options
  );
};
useEventDetailSearchQuery.getKey = (variables) => ["EventDetailSearch", variables];
useEventDetailSearchQuery.fetcher = (variables, options) => fetcher(EventDetailSearchDocument, variables, options);
const EventDetailTabDocument = "\n    query EventDetailTab($eventId: Int!, $tabId: Int!) {\n  eventGroupTab(eventId: $eventId, tabId: $tabId) {\n    id\n    groupId\n    name\n    order\n    openTime\n    closeTime\n    itemCount\n    subGroups {\n      id\n      name\n      tabId\n      order\n      viewType\n      items {\n        id\n        bookShell {\n          rentable\n          book {\n            id\n            title {\n              main\n            }\n            authors {\n              name\n              id\n              role\n            }\n            categories {\n              isSeries\n            }\n            isAdultOnly\n            isOriginal\n            priceInfo {\n              rental {\n                fullPrice\n                sellingPrice\n              }\n              purchase {\n                fullPrice\n                sellingPrice\n              }\n            }\n            ratings {\n              rating\n              count\n            }\n            series {\n              id\n              freeEpisodeCountInfo {\n                purchase\n                rental\n              }\n              isCompleted\n              priceInfo {\n                rental {\n                  minPriceNonZero\n                  minPrice\n                }\n                purchase {\n                  minPriceNonZero\n                  minPrice\n                }\n              }\n              totalEpisodeCount\n              title\n              unit\n            }\n            set {\n              totalCount\n            }\n          }\n          badges {\n            text\n            backgroundColors {\n              light\n              dark\n            }\n            urls\n            type\n          }\n          eventPageCover {\n            small\n            large\n            xxlarge\n            originalSize {\n              width\n              height\n            }\n          }\n        }\n      }\n    }\n  }\n}\n    ";
const useEventDetailTabQuery = (variables, options) => {
  return useQuery(
    ["EventDetailTab", variables],
    fetcher(EventDetailTabDocument, variables),
    options
  );
};
useEventDetailTabQuery.getKey = (variables) => ["EventDetailTab", variables];
useEventDetailTabQuery.fetcher = (variables, options) => fetcher(EventDetailTabDocument, variables, options);
const EventDetailTabOrderDocument = "\n    query EventDetailTabOrder($eventId: Int!, $tabId: Int!, $order: EventItemOrder!) {\n  eventGroupTab(eventId: $eventId, tabId: $tabId) {\n    id\n    groupId\n    name\n    order\n    openTime\n    closeTime\n    itemCount\n    items(order: $order) {\n      rentable\n      book {\n        id\n        title {\n          main\n        }\n        authors {\n          name\n          id\n          role\n        }\n        categories {\n          isSeries\n        }\n        isAdultOnly\n        isOriginal\n        priceInfo {\n          rental {\n            fullPrice\n            sellingPrice\n          }\n          purchase {\n            fullPrice\n            sellingPrice\n          }\n        }\n        ratings {\n          rating\n          count\n        }\n        series {\n          id\n          freeEpisodeCountInfo {\n            purchase\n            rental\n          }\n          isCompleted\n          priceInfo {\n            rental {\n              minPriceNonZero\n              minPrice\n            }\n            purchase {\n              minPriceNonZero\n              minPrice\n            }\n          }\n          totalEpisodeCount\n          title\n          unit\n        }\n        set {\n          totalCount\n        }\n      }\n      badges {\n        text\n        backgroundColors {\n          light\n          dark\n        }\n        urls\n        type\n      }\n      eventPageCover {\n        small\n        large\n        xxlarge\n        originalSize {\n          width\n          height\n        }\n      }\n    }\n  }\n}\n    ";
const useEventDetailTabOrderQuery = (variables, options) => {
  return useQuery(
    ["EventDetailTabOrder", variables],
    fetcher(EventDetailTabOrderDocument, variables),
    options
  );
};
useEventDetailTabOrderQuery.getKey = (variables) => [
  "EventDetailTabOrder",
  variables
];
useEventDetailTabOrderQuery.fetcher = (variables, options) => fetcher(EventDetailTabOrderDocument, variables, options);
const GroupDetailDocument = "\n    query GroupDetail($eventId: Int!, $groupIds: [Int!]) {\n  userReviewEventReward(eventId: $eventId) {\n    eventId\n    userReviewEventGroupRewards(eventGroupIds: $groupIds) {\n      eventGroupId\n      userReviewEventGroupRewardStatus {\n        acquiredRewardPoints\n        availableRewardPoints\n        reviewedItemCount\n        totalRewardPoints\n        unReviewedItemCount\n      }\n    }\n  }\n}\n    ";
const useGroupDetailQuery = (variables, options) => {
  return useQuery(
    ["GroupDetail", variables],
    fetcher(GroupDetailDocument, variables),
    options
  );
};
useGroupDetailQuery.getKey = (variables) => ["GroupDetail", variables];
useGroupDetailQuery.fetcher = (variables, options) => fetcher(GroupDetailDocument, variables, options);
const ReviewRewardNoticeDocument = "\n    query ReviewRewardNotice($eventId: Int!) {\n  event(eventId: $eventId) {\n    groups {\n      id\n      purchaseTotalNotice\n      reviewReward {\n        notice\n      }\n    }\n  }\n}\n    ";
const useReviewRewardNoticeQuery = (variables, options) => {
  return useQuery(
    ["ReviewRewardNotice", variables],
    fetcher(ReviewRewardNoticeDocument, variables),
    options
  );
};
useReviewRewardNoticeQuery.getKey = (variables) => ["ReviewRewardNotice", variables];
useReviewRewardNoticeQuery.fetcher = (variables, options) => fetcher(ReviewRewardNoticeDocument, variables, options);
const ReviewRewardReviewTotalDocument = "\n    query ReviewRewardReviewTotal($eventId: Int!) {\n  userEventReviewReward(eventId: $eventId) {\n    reviewedBookCount\n    unReviewedBookCount\n    acquiredReward\n    remainingReward\n  }\n}\n    ";
const useReviewRewardReviewTotalQuery = (variables, options) => {
  return useQuery(
    ["ReviewRewardReviewTotal", variables],
    fetcher(
      ReviewRewardReviewTotalDocument,
      variables
    ),
    options
  );
};
useReviewRewardReviewTotalQuery.getKey = (variables) => [
  "ReviewRewardReviewTotal",
  variables
];
useReviewRewardReviewTotalQuery.fetcher = (variables, options) => fetcher(
  ReviewRewardReviewTotalDocument,
  variables,
  options
);
const FindIdDocument = "\n    query FindId($email: String!) {\n  findId(email: $email) {\n    status\n    message\n    users {\n      id\n      provider\n    }\n  }\n}\n    ";
const useFindIdQuery = (variables, options) => {
  return useQuery(
    ["FindId", variables],
    fetcher(FindIdDocument, variables),
    options
  );
};
useFindIdQuery.getKey = (variables) => ["FindId", variables];
useFindIdQuery.fetcher = (variables, options) => fetcher(FindIdDocument, variables, options);
const UserInterestBookByBookDocument = "\n    query UserInterestBookByBook($bookId: String!) {\n  userInterestBookByBook(bookId: $bookId) {\n    ... on UserInterestSingleBook {\n      bookId\n      isNotificationOn\n    }\n    ... on UserInterestSeries {\n      bookId\n      isNotificationOn\n    }\n  }\n}\n    ";
const useUserInterestBookByBookQuery = (variables, options) => {
  return useQuery(
    ["UserInterestBookByBook", variables],
    fetcher(
      UserInterestBookByBookDocument,
      variables
    ),
    options
  );
};
useUserInterestBookByBookQuery.getKey = (variables) => [
  "UserInterestBookByBook",
  variables
];
useUserInterestBookByBookQuery.fetcher = (variables, options) => fetcher(
  UserInterestBookByBookDocument,
  variables,
  options
);
const KeywordFinderDocument = "\n    query KeywordFinder($genre: KeywordFinderGenre!, $tagAdultOption: AdultOption, $setId: Int) {\n  keywordFinder(genre: $genre, tagAdultOption: $tagAdultOption, setId: $setId) {\n    id\n    genre\n    title\n    sets {\n      ...KeywordFinderSet\n    }\n  }\n}\n    ".concat(KeywordFinderSetFragmentDoc);
const useKeywordFinderQuery = (variables, options) => {
  return useQuery(
    ["KeywordFinder", variables],
    fetcher(KeywordFinderDocument, variables),
    options
  );
};
useKeywordFinderQuery.getKey = (variables) => ["KeywordFinder", variables];
useKeywordFinderQuery.fetcher = (variables, options) => fetcher(KeywordFinderDocument, variables, options);
const KeywordFinderBooksDocument = "\n    query KeywordFinderBooks($tagIds: [Int!]!, $setId: Int!, $genre: KeywordFinderGenre!, $order: KeywordFinderOrder, $adultOption: AdultOption!, $pageLimitInput: PageLimitInput!, $tagAdultOption: AdultOption) {\n  keywordFinderBooks(\n    order: $order\n    tagIds: $tagIds\n    adultOption: $adultOption\n    pageLimitInput: $pageLimitInput\n    setId: $setId\n    genre: $genre\n    tagAdultOption: $tagAdultOption\n  ) {\n    items {\n      bookShell {\n        ...KeywordFinderBookShell\n      }\n      tags {\n        ...KeywordFinderTag\n      }\n    }\n    totalItemCount\n  }\n}\n    ".concat(KeywordFinderBookShellFragmentDoc, "\n").concat(KeywordFinderTagFragmentDoc);
const useKeywordFinderBooksQuery = (variables, options) => {
  return useQuery(
    ["KeywordFinderBooks", variables],
    fetcher(KeywordFinderBooksDocument, variables),
    options
  );
};
useKeywordFinderBooksQuery.getKey = (variables) => ["KeywordFinderBooks", variables];
useKeywordFinderBooksQuery.fetcher = (variables, options) => fetcher(KeywordFinderBooksDocument, variables, options);
const InterestingBookDocument = "\n    query InterestingBook($categoryIncludes: [Int!]!, $pagination: UnFixedPageLimit!, $orderFilter: UserInterestBookOrderFilter!) {\n  userInterestBook(\n    categoryIncludes: $categoryIncludes\n    pagination: $pagination\n    orderFilter: $orderFilter\n  ) {\n    items {\n      ... on UserInterestSingleBook {\n        bookId\n        isNotificationOn\n        bookShell {\n          book {\n            title {\n              main\n            }\n            author\n            author2\n          }\n          badges {\n            text\n            type\n          }\n          bookDetailPageCover {\n            xxlarge\n          }\n        }\n      }\n      ... on UserInterestSeries {\n        bookId\n        isNotificationOn\n        bookShell {\n          book {\n            title {\n              main\n            }\n            author\n            author2\n          }\n          badges {\n            text\n            type\n          }\n          bookDetailPageCover {\n            xxlarge\n          }\n        }\n        newReleaseCount\n      }\n    }\n    totalItemCount\n  }\n}\n    ";
const useInterestingBookQuery = (variables, options) => {
  return useQuery(
    ["InterestingBook", variables],
    fetcher(InterestingBookDocument, variables),
    options
  );
};
useInterestingBookQuery.getKey = (variables) => ["InterestingBook", variables];
useInterestingBookQuery.fetcher = (variables, options) => fetcher(InterestingBookDocument, variables, options);
const UserInterestBookFilterDocument = "\n    query UserInterestBookFilter {\n  userInterestBookFilter {\n    children {\n      id\n      name\n      range\n      count\n      children {\n        id\n        name\n        range\n        count\n        children {\n          id\n          name\n          range\n          count\n        }\n      }\n    }\n  }\n}\n    ";
const useUserInterestBookFilterQuery = (variables, options) => {
  return useQuery(
    variables === void 0 ? ["UserInterestBookFilter"] : ["UserInterestBookFilter", variables],
    fetcher(
      UserInterestBookFilterDocument,
      variables
    ),
    options
  );
};
useUserInterestBookFilterQuery.getKey = (variables) => variables === void 0 ? ["UserInterestBookFilter"] : ["UserInterestBookFilter", variables];
useUserInterestBookFilterQuery.fetcher = (variables, options) => fetcher(
  UserInterestBookFilterDocument,
  variables,
  options
);
const MeDocument = "\n    query Me {\n  me {\n    id\n    idx\n    email\n    socials {\n      provider\n    }\n  }\n}\n    ";
const useMeQuery = (variables, options) => {
  return useQuery(
    variables === void 0 ? ["Me"] : ["Me", variables],
    fetcher(MeDocument, variables),
    options
  );
};
useMeQuery.getKey = (variables) => variables === void 0 ? ["Me"] : ["Me", variables];
useMeQuery.fetcher = (variables, options) => fetcher(MeDocument, variables, options);
const NewReleasesDocument = "\n    query NewReleases($categoryIncludes: [Int!]!, $adultOption: AdultOption!, $pageLimitInput: PageLimitInput!, $categoryExcludes: [Int!], $order: NewReleaseOrder, $onlyRentAvailable: Boolean, $seriesCompleted: Boolean) {\n  newReleases(\n    categoryIncludes: $categoryIncludes\n    adultOption: $adultOption\n    pageLimitInput: $pageLimitInput\n    categoryExcludes: $categoryExcludes\n    order: $order\n    onlyRentAvailable: $onlyRentAvailable\n    seriesCompleted: $seriesCompleted\n  ) {\n    items {\n      bookShell {\n        ...BookShell\n      }\n    }\n    totalItemCount\n    pagination {\n      ... on PageLimitOutput {\n        input {\n          page\n          limit\n        }\n        offset\n        hasMore\n      }\n    }\n  }\n}\n    ".concat(BookShellFragmentDoc);
const useNewReleasesQuery = (variables, options) => {
  return useQuery(
    ["NewReleases", variables],
    fetcher(NewReleasesDocument, variables),
    options
  );
};
useNewReleasesQuery.getKey = (variables) => ["NewReleases", variables];
useNewReleasesQuery.fetcher = (variables, options) => fetcher(NewReleasesDocument, variables, options);
const NotificationsDocument = "\n    query Notifications($notificationTabId: Int, $limit: Int, $after: String) {\n  notifications(\n    notificationTabId: $notificationTabId\n    limit: $limit\n    after: $after\n  ) {\n    items {\n      campaignId\n      createdAt\n      id\n      landingUrl\n      message\n      messageType\n      notificationTabId\n      readAt\n      relativeCreatedAt\n      tags\n      title\n      image {\n        dark\n        light\n        type\n      }\n    }\n    pagination {\n      after\n      hasMore\n    }\n  }\n}\n    ";
const useNotificationsQuery = (variables, options) => {
  return useQuery(
    variables === void 0 ? ["Notifications"] : ["Notifications", variables],
    fetcher(NotificationsDocument, variables),
    options
  );
};
useNotificationsQuery.getKey = (variables) => variables === void 0 ? ["Notifications"] : ["Notifications", variables];
useNotificationsQuery.fetcher = (variables, options) => fetcher(NotificationsDocument, variables, options);
const NotificationTabsDocument = "\n    query notificationTabs {\n  notificationTabs {\n    id\n    name\n  }\n}\n    ";
const useNotificationTabsQuery = (variables, options) => {
  return useQuery(
    variables === void 0 ? ["notificationTabs"] : ["notificationTabs", variables],
    fetcher(NotificationTabsDocument, variables),
    options
  );
};
useNotificationTabsQuery.getKey = (variables) => variables === void 0 ? ["notificationTabs"] : ["notificationTabs", variables];
useNotificationTabsQuery.fetcher = (variables, options) => fetcher(NotificationTabsDocument, variables, options);
const SetPasswordDocument = "\n    query SetPassword {\n  setPassword {\n    status\n    message\n  }\n}\n    ";
const useSetPasswordQuery = (variables, options) => {
  return useQuery(
    variables === void 0 ? ["SetPassword"] : ["SetPassword", variables],
    fetcher(SetPasswordDocument, variables),
    options
  );
};
useSetPasswordQuery.getKey = (variables) => variables === void 0 ? ["SetPassword"] : ["SetPassword", variables];
useSetPasswordQuery.fetcher = (variables, options) => fetcher(SetPasswordDocument, variables, options);

export { AddDeliveryInfoCollectConsentDocument, AddRecentlyViewedBooksResponseStatus, AddRidiAwardGenreVoteStatus, AddUserInterestBookDocument, AddUserInterestBookResponseStatus, AddWishlistStatus, AdultOption, AdultVerificationStatus, AiRecommendationDocument, AppMarketingBridgeButtonType, AsyncCellLoadTiming, AuthorRole, BadgeType, BannerPlace, BestSellersDocument, BestsellerPeriod, BookBadgeFragmentDoc, BookBaseFragmentDoc, BookDetailHomeBaseReviewType, BookDetailHomeEpisodeBookListFirstCallOption, BookDetailHomeEpisodeBookOrder, BookDetailHomeEpisodeBookOwnershipStatus, BookDetailHomeEpisodeBookPaginationDirection, BookDetailHomeHeaderButtonAction, BookDetailHomeReviewOrder, BookShellFragmentDoc, BooksDetailAsideBannerItemFragmentDoc, BooksDetailAsideBestSellerItemFragmentDoc, BooksDetailAsideDocument, BooksDetailMetadataCategoryFragmentDoc, BooksDetailMetadataDocument, BooksDetailSectionsDocument, CacheControlScope, CategoryGenreFilterRangeType, CellBindingType, CellLayout, CreateDeliveryInfoDocument, CreateDeliveryInfoStatus, DeliveryInfoCollectConsentStatus, DeliveryInfoCollectTargetDocument, DeliveryInfoCollectTargetStatus, DeliveryInfoDocument, DeliveryInfosDocument, DeviceType, DurationUnitType, EventDetailBookLandscapeDataFragmentDoc, EventDetailBookLandscapeDocument, EventDetailEventDocument, EventDetailGroupMetadataFragmentDoc, EventDetailMetadataDocument, EventDetailOwnershipsDocument, EventDetailSearchDocument, EventDetailTabDocument, EventDetailTabOrderDocument, EventGenre, EventGroupType, EventItemOrder, EventSubGroupViewType, EventType, ExtendedOwnershipType, FileFormat, FindIdDocument, FindIdStatus, FindPasswordStatus, Gender, GridLayout, GridType, GroupDetailDocument, InterestingBookDocument, IpGoodsFragmentDoc, KeywordFinderBookShellFragmentDoc, KeywordFinderBooksDocument, KeywordFinderDocument, KeywordFinderGenre, KeywordFinderOrder, KeywordFinderSetFragmentDoc, KeywordFinderSetGroupFragmentDoc, KeywordFinderSetKeywordFragmentDoc, KeywordFinderTagFragmentDoc, LandscapeBookBaseFragmentDoc, LandscapeBookShellFragmentDoc, MeDocument, ModifyDeliveryInfoDocument, ModifyDeliveryInfoStatus, ModifyNewBookNotificationUseDocument, ModifyNewBookNotificationUseStatus, NewReleaseOrder, NewReleasesDocument, NotificationTabsDocument, NotificationsDocument, OwnershipType, Period, Platform, Portrait3InfoBookBaseFragmentDoc, Portrait3InfoBookShellFragmentDoc, RatingStar, ReadNotificationDocument, ReadNotificationStatus, ReadRecordType, RecentReadFilterRangeType, RecommendBestSellersDocument, RecommendSimBy, RelatedSeriesInfoFragmentDoc, RemoveDeliveryInfoCollectConsentDocument, RemoveRecentReadsOption, RemoveRecentReadsStatus, RemoveUserInterestBookDocument, RemoveUserInterestBookOption, RemoveUserInterestBookResponseStatus, RemoveWishlistStatus, ReviewRewardNoticeDocument, ReviewRewardReviewTotalDocument, RidiAwardGenrePropertyType, RidiAwardGenreUserStatusType, RidiAwardUserStatusType, SearchOrder, SearchSite, SearchWhat, SearchWhere, SetBookOption, SetPasswordDocument, SetPasswordStatus, SocialProvider, UserInterestBookByBookDocument, UserInterestBookFilterDocument, UserInterestBookOrderFilter, UserInterestBookType, UserReviewStatusType, WishlistOrder, useAddDeliveryInfoCollectConsentMutation, useAddUserInterestBookMutation, useAiRecommendationQuery, useBestSellersQuery, useBooksDetailAsideQuery, useBooksDetailMetadataQuery, useBooksDetailSectionsQuery, useCreateDeliveryInfoMutation, useDeliveryInfoCollectTargetQuery, useDeliveryInfoQuery, useDeliveryInfosQuery, useEventDetailBookLandscapeQuery, useEventDetailEventQuery, useEventDetailMetadataQuery, useEventDetailOwnershipsQuery, useEventDetailSearchQuery, useEventDetailTabOrderQuery, useEventDetailTabQuery, useFindIdQuery, useGroupDetailQuery, useInterestingBookQuery, useKeywordFinderBooksQuery, useKeywordFinderQuery, useMeQuery, useModifyDeliveryInfoMutation, useModifyNewBookNotificationUseMutation, useNewReleasesQuery, useNotificationTabsQuery, useNotificationsQuery, useReadNotificationMutation, useRecommendBestSellersQuery, useRemoveDeliveryInfoCollectConsentMutation, useRemoveUserInterestBookMutation, useReviewRewardNoticeQuery, useReviewRewardReviewTotalQuery, useSetPasswordQuery, useUserInterestBookByBookQuery, useUserInterestBookFilterQuery };
